export enum ENovaplaceBannerFormatType {
  B2B_SUPER_BANNER = 'B2B_SUPER_BANNER',
  B2B_BANNER = 'B2B_BANNER',
}

export interface INovaplaceBanner {
  CampaignId: string;
  Image: string;
  Link: string;
  Advertisement: boolean;
  AdditionalImage: string;
  FormatType: ENovaplaceBannerFormatType;
}

export enum ENovaplaceClientType {
  Private = 'private',
  Business = 'business',
  Corporate = 'corporate',
}

export interface INovaplaceBusinessContactsPayload {
  ClientType: ENovaplaceClientType;
  UserLogin?: string;
  CounterpartyRefs?: string[];
}

export interface INovaplaceBusinessFocusPayload extends INovaplaceBusinessContactsPayload {
  CampaignId: string;
}

export interface INovaplaceBusinessActionPayload extends INovaplaceBusinessContactsPayload {
  CampaignId: string;
}

export interface INovaplaceBusinessClosePayload extends INovaplaceBusinessContactsPayload {
  CampaignId: string;
}

export interface INovaplaceBusinessActionLink {
  Link: string;
}
